import { useTranslation } from '@mint-lib/i18n';
import { Alert } from '@mint-lib/tw-components/patterns';

export const ConnectionWrongCustomerAlert = () => {
  const { t } = useTranslation('@mint-lib/connections-ui');

  return (
    <Alert
      severity="warning"
      variant="multiline"
      removable={false}
      title={t('No advertiser access.')}
      description={t(
        "You don't have access to the advertiser, please contact your manager to gain access, and then do a reconnection.",
      )}
    />
  );
};
